import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "devicetype-packetparser"
  }, [_c(VExpansionPanels, {
    staticClass: "my-4 calculate-elements",
    attrs: {
      "value": 0,
      "flat": ""
    }
  }, [_c(VExpansionPanel, {
    attrs: {
      "data-cy": "fn-parser-calculations"
    }
  }, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v("\n          " + _vm._s(_vm.switchParserMode ? _vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.calculateHeaderSwitchParser') : _vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.calculateHeader')) + "\n        ")])]), _c(VExpansionPanelContent, [!_vm.calculateElementsInternal || !_vm.calculateElementsInternal.length ? _c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12",
      "align": "right"
    }
  }, [_vm.isIotHubManager ? _c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-plus"
    },
    on: {
      "click": function ($event) {
        return _vm.addCalculateElement(0);
      }
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._l(_vm.calculateElementsInternal, function (cElement, i) {
    return _c(VRow, {
      key: `c-element-${i}`
    }, [_c(VCol, {
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c(VTextField, {
      attrs: {
        "data-cy": `formula_${i}`,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": [_vm.requiredRuleForVariable(cElement)],
        "disabled": !_vm.isIotHubManager || _vm.formSaving || _vm.readonly,
        "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.formula'),
        "hide-details": "auto",
        "autocomplete": "off",
        "required": ""
      },
      on: {
        "change": _vm.onInputsChanged
      },
      model: {
        value: cElement.formula,
        callback: function ($$v) {
          _vm.$set(cElement, "formula", $$v);
        },
        expression: "cElement.formula"
      }
    })], 1), _c(VCol, {
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c(VTextField, {
      attrs: {
        "data-cy": `target_variable${i}`,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": [_vm.parserTargetNameRule(cElement)],
        "disabled": !_vm.isIotHubManager || _vm.formSaving || _vm.readonly,
        "label": _vm.switchParserMode ? _vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.targetVariableSwitchParser') : _vm.$i18n_t('NiotaClassic.DeviceTypes.form.parser.targetVariable'),
        "hide-details": "auto",
        "autocomplete": "off",
        "required": ""
      },
      on: {
        "change": _vm.onInputsChanged
      },
      scopedSlots: _vm._u([{
        key: "append-outer",
        fn: function () {
          return [_vm.isIotHubManager ? _c('core-button', {
            attrs: {
              "color": _vm.color,
              "disabled": _vm.readonly,
              "prepend-icon": "fa-plus",
              "data-cy": `add_calculation_${i}`
            },
            on: {
              "click": function ($event) {
                return _vm.addCalculateElement(i);
              }
            }
          }) : _vm._e(), _vm.isIotHubManager ? _c('core-button', {
            attrs: {
              "color": _vm.color,
              "disabled": _vm.readonly,
              "prepend-icon": "fa-trash-alt",
              "data-cy": `remove_calculation_${i}`
            },
            on: {
              "click": function ($event) {
                return _vm.removeCalculateElement(i);
              }
            }
          }) : _vm._e()];
        },
        proxy: true
      }], null, true),
      model: {
        value: cElement.target,
        callback: function ($$v) {
          _vm.$set(cElement, "target", $$v);
        },
        expression: "cElement.target"
      }
    })], 1), _c(VDivider)], 1);
  })], 2)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };